/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainLayout from 'components/layouts/main'
import {
  deleteDuplicateFPHistory,
  getDegodsFields,
  getDuplicateMagicEdenSlugs,
  getMissingHyperspaceSlugsList,
  getTestList,
  setCollectionInactive,
  setCollectionInactiveDuplicateMeSlugs,
  topSolCollectionsBrokenVolume,
} from 'services'
import Button from 'components/commons/button'
import { notifySuccess } from 'components/commons/toast'
import { ToastContainer } from 'react-toastify'

const SolanaVolumeCheck = () => {
  const [solCollection, setSolCollections] = useState<any>([])

  useEffect(() => {
    getFields()
  }, [])

  const getFields = async () => {
    topSolCollectionsBrokenVolume().then((list: any) => {
      setSolCollections(list)
    })
  }

  const setInactiveDuplicateCollection = async (id: any) => {
    setCollectionInactiveDuplicateMeSlugs(id)
    notifySuccess('Success!')
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Solana Volume Check
          </h1>
        </div>

        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            SOL NFTs Volume Issue
          </h1>

          <div style={{ paddingLeft: 24 }}>
            {solCollection.map((doc: any) => (
              <div
                key={doc.id}
                className='flex flex-row'
                style={{ alignItems: 'center', marginBottom: 24 }}
              >
                <img src={doc.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                <div className='flex flex-col'>
                  <b>
                    <p>
                      {''} {doc.name} {' - Total Vol:'} {doc?.stats?.total_volume}
                    </p>
                  </b>
                  <div>
                    {doc?.brokenVolume.map((fpPoint: any) => (
                      <p key={fpPoint.id}>
                        {fpPoint.id}
                        {' - '}
                        {fpPoint.price_date}
                        {' -  1D Vol: '} {fpPoint?.one_day_volume}
                        {' -  1D Sales: '}
                        {fpPoint?.one_day_sales}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default SolanaVolumeCheck
